// extracted by mini-css-extract-plugin
export var actionText = "_p5-4";
export var container = "_p5-0";
export var leftSection = "_p5-1";
export var rightSection = "_p5-2";
export var settingsButton = "_p5-6";
export var settingsIcon = "_p5-7";
export var shortcut = "_p5-5";
export var shortcutGroup = "_p5-3";